<script>

    import { replace } from 'svelte-spa-router'
    import { adminStore } from '../stores'
    import { isPermission } from '../$methods/permissions.methods'

    import View from '../$layouts/view.layout.svelte'
    import PageHeader from '../$components/page.header.svelte'
    import Modal from '../$components/modal.container.svelte'

    import CreditsComponent from './component.credits.svelte'
    import CreditComponent from './component.credit.svelte'
    import CreditUpdateComponent from './component.update.svelte'
    import CreditsReportComponent from './component.credits.report.svelte'

    if(!isPermission($adminStore, 'UsersView.Credits.View'))
        replace('/404')

</script>

<View>
    <PageHeader title="Créditos" subtitle="Recargas y créditos de usuarios" />
    <CreditsComponent all={true} />
</View>

<Modal id="credit_modal" title="Crédito" >
    <CreditComponent />
</Modal>

<Modal id="credit_update_modal" title="Actualizar crédito" >
    <CreditUpdateComponent />
</Modal>

<Modal id="credits_report_modal" title="Reporte créditos" >
    <CreditsReportComponent />
</Modal>
